package components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.css.*

/**
 * QR Code display component for web platform
 *
 * @param data The URL of the QR code image
 * @param size The size of the QR code in pixels
 * @param contentDescription Accessibility description for the QR code
 */
@Composable
fun QrCodeView(
    data: String,
    size: Int = 200,
    contentDescription: String? = null,
) {
    Img(src = data, alt = contentDescription ?: "QR Code") {
        style {
            width(size.px)
            height(size.px)
            display(DisplayStyle.Block)
        }
    }
}
